
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

import { mapGetters, mapActions, mapState } from "vuex";

export default {
  page: {
    title: "Drug Dispensing",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  components: {
    Layout,
    PageHeader,
  },

  data() {
    return {
      title: "Drug Dispensing",
      items: [
        {
          text: "Pharmacy Section",
          href: "#",
        },
        {
          text: "Drug Dispensing",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [15, 25, 50, 100, 250, 500, 1000],
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
        {
          key: "patientName",
          sortable: true,
          label: "PATIENT NAME",
        },
        {
          key: "patient.patientName",
          sortable: true,
          label: "PATIENT NUMBER",
        },
        {
          key: "drugs",
          sortable: true,
          label: "DRUGS",
        },
        {
          key: "action",
          sortable: false,
          label: "DISPENSE",
        },
      ],
      model_id: "",
      qtyError: "",
      medicationError: "",
      editData: {
        id: "",
        name: "",
        quantity: "",
        medication: "",
        notDoctor: true,
      },
      singleData: {
        id: "",
        name: "",
      },
      allData: {
        client: "",
        visit: "",
      },
      deleteData: {
        id: "",
        name: "",
      },
    };
  },

  computed: {
    ...mapGetters("pharmacy", ["DrugDispense", "DispenseState"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    rows() {
      return this.DrugDispense ? this.DrugDispense.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.DrugDispense ? this.DrugDispense.length : 1;
  },
  watch: {
    notification_show(newValue) {
      if (newValue === true) {
        this.closeModal(this.model_id);
        if (this.notificationtype === "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchDispensing: "pharmacy/fetchDispensingDrug",
      UpdateQuantity: "pharmacy/UpdatePrescription",
      DeletePrescription: "pharmacy/RemovePrescription",
      DispenseDrug: "pharmacy/DispenseOneDrug",
      DispenseAll: "pharmacy/DispenseAllDrug",
    }),

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering Separator
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    //  EDIT PRESCRIBED DRUG==============
    //  SHOW EDIT MODAL
    showEditModal(item) {
      this.editData.id = item.id;
      this.editData.name = item.item.serviceName;
      this.editData.quantity = item.dispensed;
      this.editData.medication = item.medication;
      this.editData.notDoctor = true;
    },
    //  CONFIRM CHANGES
    confirmEdit(modalId) {
      this.model_id = modalId;
      if (this.editData.quantity == "" || this.editData.quantity == null) {
        // console.log(this.editData.quantity)
        this.qtyError = "Quantity field is required or Delete it instead";
        return;
      }
      let qty = parseInt(this.editData.quantity);
      // alert(qty)
      // console.log(qty)
      if (qty < 1) {
        this.qtyError = "Quantity can not be less than one, Delete it instead";
        return;
      }
      if (this.editData.medication == "" || this.editData.medication == null) {
        this.medicationError = "Medication field is required";
        return;
      }
      //dispatch to endpoint
      this.UpdateQuantity(this.editData);
    },
    //  RESET EDIT MODAL
    resetEdit() {
      this.qtyError = "";
      this.medicationError = "";
      this.editData.quantity = "";
      this.editData.id = "";
      this.editData.name = "";
      this.editData.medication = "";
    },

    //  DELETE PRESCRIBED DRUG==============
    //  SHOW DELETE MODAL
    showDeleteModal(item) {
      this.deleteData.id = item.id;
      this.deleteData.name = item.item.serviceName;
    },

    //DELETE
    confirmDelete(modalId) {
      this.model_id = modalId;
      //dispatch to endpoint
      this.DeletePrescription(this.deleteData);
    },

    //  RESET DELETE MODAL
    resetDelete() {
      this.deleteData.id = "";
      this.deleteData.name = "";
    },

    //  DISPENSE PRESCRIBED DRUG ONE BY ONE ==============
    //  SHOW DISPENSE MODAL
    showSingleModal(item) {
      this.singleData.id = item.id;
      this.singleData.name = item.item.serviceName;
      this.singleData.visit = item.visit_id;
    },

    //DISPENSE
    confirmSingle(modalId) {
      this.model_id = modalId;
      //dispatch to endpoint
      this.DispenseDrug(this.singleData);
    },

    //  RESET single MODAL
    resetSingle() {
      this.singleData.id = "";
      this.singleData.name = "";
    },

    //  DISPENSE PRESCRIBED DRUGS ALL AT ONCE ==============
    //  SHOW DISPENSE MODAL
    showAllModal(item) {
      this.allData.client = item.item.patient.patientName;
      this.allData.visit = item.item.id;
    },

    //DISPENSE
    confirmAll(modalId) {
      this.model_id = modalId;
      //dispatch to endpoint
      this.DispenseAll(this.allData);
    },

    //  RESET single MODAL
    resetAll() {
      this.allData.client = "";
      this.allData.visit = "";
    },

    //  RESET ERROR
    resetError() {
      this.qtyError = "";
      this.medicationError = "";
    },
    // CLOSE MODEL
    closeModal(modelId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modelId);
      });
    },
  },
  created() {
    this.FetchDispensing();
  },
};
</script>

<style lang="css" scoped></style>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :items="items" :title="title" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      :options="pageOptions"
                      class="form-select form-select-sm"
                      size="sm"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      class="form-control form-control-sm ms-2"
                      placeholder="Search..."
                      type="search"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :current-page="currentPage"
                :fields="fields"
                :filter="filter"
                :filter-included-fields="filterOn"
                :items="this.DrugDispense"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                bordered
                class="datatables"
                responsive="sm"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                 <template #cell(patientName)="data">
                  {{ data.item.patient.patientName }}
                   <span
                    class="badge rounded-pill bg-success"
                    v-if="data.item.pay_status == 'Cleared'"
                    >Cleared</span
                  >
                   <span
                    class="badge rounded-pill bg-primary"
                    v-else-if="data.item.pay_status == 'insured'"
                    >Insured</span
                  >
                  <span
                    class="badge rounded-pill bg-danger"
                    v-else
                  >
                   Haven't Cleared</span
                  >
                
                </template>
                
                <template #cell(drugs)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Drug Name</th>
                        <th>Qty</th>
                        <th>Amount</th>
                        <th>Dosage</th>
                        <th>Bill</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(drug, d) in data.item.prescriptions" :key="d">
                        <td>{{ drug.item.drug }}</td>
                        <td>
                          {{ drug.dispensed
                          }}{{ drug.item.unit ? drug.item.unit.symbol : "" }}
                        </td>
                        <td>{{ drug.itemPrice }}</td>
                        <td>{{ drug.medication }}</td>
                        <td>
                          <span v-if="drug.isInsured == 1">Insured</span>
                          <span v-if="drug.isInsured == 0">Personal</span>
                        </td>
                        <td>
                          <!-- Dispense one button -->
                          <!-- <b-button
                            v-if="user_permissions.dispense_priscription"
                            v-b-modal.edit-modal
                            @click="showEditModal(drug)"
                            size="sm"
                            title="Edit prescribed drug"
                            variant="primary"
                            ><i class="fa fa-edit"></i
                          ></b-button> -->
                          <!-- <b-button
                            v-else
                            disabled
                            v-b-modal.edit-modal
                            @click="showEditModal(drug)"
                            size="sm"
                            title="Edit prescribed drug"
                            variant="primary"
                            ><i class="fa fa-edit"></i
                          ></b-button> -->
                          <!-- | -->
                          <!-- Dispense one button -->
                          <b-button
                            v-if="user_permissions.dispense_priscription==1"
                            v-b-modal.delete-modal
                            @click="showDeleteModal(drug)"
                            size="sm"
                            title="Remove drug from prescription"
                            variant="danger"
                            ><i class="fa fa-times"></i
                          ></b-button>
                          <b-button
                            v-else
                            size="sm"
                            title="You are restricted"
                            variant="danger"
                            ><i class="fa fa-ban"></i
                          ></b-button>
                          |
                          <!-- Dispense one button -->
                          <b-button
                            v-if="user_permissions.dispense_priscription"
                            v-b-modal.dispense-single
                            @click="showSingleModal(drug)"
                            size="sm"
                            title="Dispense drug"
                            variant="secondary"
                            ><i class="fa fa-check"></i
                          ></b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(action)="data">
                  <!-- Dispense all button -->
                  <b-button
                    v-if="user_permissions.dispense_priscription"
                    v-b-modal.dispense-all
                    @click="showAllModal(data)"
                    size="sm"
                    title="Dispense all drug at once"
                    variant="secondary"
                    ><i class="fa fa-check"></i>
                    All
                  </b-button>
                  <b-button
                    v-else
                    disabled
                    v-b-modal.dispense-all
                    @click="showAllModal(data)"
                    size="sm"
                    title="Dispense all drug at once"
                    variant="secondary"
                    ><i class="fa fa-check"></i>
                    All
                  </b-button>
                </template>
              </b-table>
              <h3 v-if="!this.DrugDispense" class="text-primary text-center">
                <b-spinner class="m-0" role="status" variant="primary"></b-spinner>
                Please wait...
              </h3>
            </div>

            <!-- EDIT PRESCRIBED DRUG -->
            <b-modal id="edit-modal" ref="modal" hide-footer @hidden="resetEdit">
              <template #modal-title>
                <p class="text-uppercase">Update {{ editData.name }}</p>
              </template>
              <div class="mb-3">
                <label>Prescribed Quantity:</label>
                <input
                  v-model="editData.quantity"
                  class="form-control"
                  type="number"
                  @input="resetError"
                />
                <div class="text-danger" v-if="qtyError">
                  <em>{{ qtyError }}</em>
                </div>
              </div>
              <div class="mb-3">
                <label>Dosage:</label>
                <textarea
                  v-model="editData.medication"
                  class="form-control"
                  @input="resetError"
                ></textarea>
                <div class="text-danger" v-if="medicationError">
                  <em>{{ medicationError }}</em>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('edit-modal')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="confirmEdit('edit-modal')"
                >
                  Save Changes
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- EDIT PRESCRIBED DRUG -->

            <!-- DELETE PRESCRIBED DRUG -->
            <b-modal id="delete-modal" ref="modal" hide-footer @hidden="resetDelete">
              <template #modal-title>
                <p class="text-uppercase">Delete {{ deleteData.name }}</p>
              </template>
              <h3 class="text-center">
                Are you sure to delete <code>{{ deleteData.name }}</code> prescription?
                <br />
                Click <code>REMOVE</code> to continue.
              </h3>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('delete-modal')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-danger"
                  type="button"
                  @click="confirmDelete('delete-modal')"
                >
                  Remove
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- DELETE PRESCRIBED DRUG -->

            <!-- DISPENSE SINGLE DRUG -->
            <b-modal id="dispense-single" ref="modal" hide-footer @hidden="resetSingle">
              <template #modal-title>
                <p class="text-uppercase">Dispense {{ singleData.name }}</p>
              </template>
              <h3 class="text-center">
                To dispense <code>{{ singleData.name }}</code> prescription, Click
                <code>DISPENSE</code> to continue.
              </h3>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('dispense-single')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="confirmSingle('dispense-single')"
                >
                  Dispense
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- DISPENSE SINGLE DRUG -->

            <!-- DISPENSE SINGLE DRUG -->
            <b-modal id="dispense-all" ref="modal" hide-footer @hidden="resetAll">
              <template #modal-title>
                <p class="text-uppercase">Dispense {{ allData.client }}</p>
              </template>
              <h3 class="text-center">
                To dispense all <code>{{ allData.client }}</code> prescribed drugs, Click
                <code>DISPENSE</code>.
              </h3>
              <div class="modal-footer">
                <button
                  class="btn btn-secondary"
                  @click="$bvModal.hide('dispense-all')"
                  type="button"
                >
                  Close
                </button>
                <button
                  class="btn btn-primary"
                  type="button"
                  @click="confirmAll('dispense-all')"
                >
                  Dispense
                  <b-spinner
                    v-if="DispenseState"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- DISPENSE SINGLE DRUG -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
